// extracted by mini-css-extract-plugin
export default {"wrapper":"PageLayout_wrapper__21E09","container":"PageLayout_container__TggXE"};